import React, { type FC, type SVGProps } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Close from '@jwp/ott-theme/assets/icons/close.svg?react';

import IconButton from '../IconButton/IconButton';
import Icon from '../Icon/Icon';

import styles from './ModalCloseButton.module.scss';

type Props = {
  onClick?: () => void;
  visible?: boolean;
  icon?: FC<SVGProps<SVGSVGElement>>;
  variant?: 'default' | 'outlined';
};

const ModalCloseButton: React.FC<Props> = ({ onClick, visible = true, icon = Close, variant = 'default' }: Props) => {
  const { t } = useTranslation('common');
  const isStrokeIcon = icon !== Close;

  return (
    <IconButton
      onClick={onClick}
      aria-label={t('close_modal')}
      className={classNames(styles.modalCloseButton, { [styles.hidden]: !visible, [styles.outlined]: variant === 'outlined' })}
    >
      <Icon icon={icon} className={isStrokeIcon ? styles.strokeIcon : undefined} />
    </IconButton>
  );
};

export default ModalCloseButton;
